import axiosClient from "../api/axiosClient";
import { dateFormate, decryptedAdminID, getCurrentDateTime } from "../utility";
const formattedDateTime = getCurrentDateTime();
export const getInterviewSchedulePosibility = async (params) => {
  const response = await axiosClient.get("/posibilityForCandidate", {
    params,
  });

  return response.data;
};
export const getJobLocationFormJobId = async (jobId) => {
  const response = await axiosClient.get("/getjobLocation", {
    params: { jobId },
  });

  return response.data;
};

export const getpipelineReasonNames = async (stageId) => {
  const response = await axiosClient.get(`/getpipelineReasonNames/${stageId}`);

  return response.data.data;
};

export const postInterviewSchedule = async (obj) => {
  const adminID = decryptedAdminID();
    // const adminID = 1;

  const params = {
    can_id: obj.candidateId,
    job_id: obj.jobId,
    interview_date: dateFormate(obj.date).trim(),
    admin_id: adminID,
    candidate_percentage: obj.candidatePercentage,
    // emergencyContactNumber: obj.EmeregncyContactNumber,
    // relationshipType: obj.Relationship,
    // relationName: obj.RelationshipName,
    // date: formattedDateTime,
  };

  const { data } = await axiosClient.post("/sendInterviewAlert", null, {
    params,
  });

  return data;
};

export const scheduleInterview = async (obj) => {
  const adminID = Number(decryptedAdminID());

  const body = {
    admin_id: adminID,
    job_id: Number(obj.jobId),
    emp_id: 1269,
    can_id: Number(obj.candidateId),
    interview_date: dateFormate(obj.date).trim(),
    candidate_percentage: obj.candidatePercentage,
  };

  const response = await axiosClient.post("/scheduleInterview", body, {
    validateStatus: () => true, // ✅ IMPORTANT FIX
  });

  return response.data;
};
export const updateInterviewStatus = async (obj) => {
  const body = {
    interview_id: obj.interview_id,
    from_stage_id: obj.from_stage_id,
    to_stage_id: obj.to_stage_id,
    from_sub_stage_id: obj.from_sub_stage_id,
    to_sub_stage_id: obj.to_sub_stage_id,
    moved_by: obj.moved_by,
    reason_id: obj.reason_id,
    custom_reason: obj.custom_reason,
    notes: obj.notes,
    event_date:obj.event_date
  };

  const { data } = await axiosClient.post("/updateInterviewStatus", body);

  return data;
};

export const getInterviewFilter = async (payload) => {
  const { data } = await axiosClient.post("/getInterviewFilter", payload);
  return data;
}

export const updateInterviewAdminID = ({ id, admin_id }) => {
  const adminID = decryptedAdminID();

  return axiosClient.put(
    `/updateInterviewAdminId/${id}/${adminID}`,
    { admin_id }
  );
};